import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostBinding, OnInit } from '@angular/core';
import { UserService } from './shared/service/user-service';
import { ThemeService } from './theme';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

// const THEME_DARKNESS_SUFFIX = `-dark`;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'CrescoJobs';
  currentLanguage: string = 'en'

  //   themes: string[] = [
  // 		"deeppurple-amber",
  // 		"indigo-pink",
  // 		"pink-bluegrey",
  // 		"purple-green",
  // 	];

  // 	@HostBinding('class') activeThemeCssClass: string;
  // 	isThemeDark = false;
  // 	activeTheme: string;

  //   setTheme(theme: string, darkness: boolean = null) {
  // 		if (darkness === null)
  // 			darkness = this.isThemeDark;
  // 		else if (this.isThemeDark === darkness) {
  // 			if (this.activeTheme === theme) return;
  // 		} else
  // 			this.isThemeDark = darkness;

  // 		this.activeTheme = theme;

  // 		const cssClass = darkness === true ? theme + THEME_DARKNESS_SUFFIX : theme;

  // 		const classList = this.overlayContainer.getContainerElement().classList;
  // 		if (classList.contains(this.activeThemeCssClass))
  // 			classList.replace(this.activeThemeCssClass, cssClass);
  // 		else
  // 			classList.add(cssClass);

  // 		this.activeThemeCssClass = cssClass;
  // 	}

  // 	toggleDarkness() {
  // 		this.setTheme(this.activeTheme, !this.isThemeDark);
  // 	}

  constructor(private router: Router, private route: ActivatedRoute, private overlayContainer: OverlayContainer, private userService: UserService, private themeService: ThemeService,) {
    this.userService.themesDatastring$.subscribe(e => {
      if (e != '' && e != ' ' && e != undefined && e != null && e != 'null') {
        this.themeService.setTheme(e);
      }
    })
  }

  ngOnInit() {
    // Listen for NavigationStart event globally
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
      // This will run before navigation starts - Sets the Language Visiblity Default True
      this.userService.setLanguageButtonVisiblity(true);
    });

    // Extracting the x_tr_tl query parameter
    this.route.queryParams.subscribe(params => {
      if (params && params['_x_tr_tl'] && params['_x_tr_tl'] !== null && params['_x_tr_tl'].trim() !== '' && params['_x_tr_tl'] !== undefined) {
        this.currentLanguage = params['_x_tr_tl'];
        sessionStorage.setItem("currentlanguage", this.currentLanguage);
      }
    });
  }
}
